<!--
 * @Author: pansp
 * @Date: 2024-12-27 14:29:09
 * @LastEditors: pansp
 * @LastEditTime: 2025-02-11 18:10:41
 * @Description: 
 * @FilePath: /Allo-H5-main/src/views/tutorial/index.vue
-->
<template>
  <div class="tutorial-container">
    <div class="tutorial">
      <video ref="videoRef" :src="videoUrl" :poster="coverUrl" type="video/mp4" class="video-player" controls
        controlsList="nodownload noplaybackrate" disablepictureinpicture></video>
    </div>
  </div>
</template>

<script>
import { videoPlayEndCallback, liveVideoPlayEndCallback } from '@/api/index'
import { CommonModule } from '@/store/modules/common'
import { isIOS } from '@/utils/device/index'
export default {
  data() {
    return {
      language: '',
      isShow: true,
      coverUrl: 'https://source.allosoft.top/h5/main/img/guide.png',
      videoUrl:
        'https://source.allosoft.top/h5/main/video/guide.mp4',
      sourceType: 1,   // 1 聊天教程  2 语音房教程
    }
  },
  created() {
    // 获取当前语言
    const data = this.$route.query?.language || 'ug'
    this.sourceType =   isIOS ?  this.$route.query?.sourceType || 1  :  this.$route.query?.type || 1
    
    //  处理不同教程  1 聊天教程  2 语音房教程
    if (this.sourceType == 1) {
      this.videoUrl = 'https://source.allosoft.top/h5/main/video/voice_room.mp4'
      this.coverUrl = 'https://source.allosoft.top/h5/main/img/guide.png'
    } else if (this.sourceType == 2) {
      this.videoUrl = 'https://source.cdtongxiaoyun.com/web/mungdax_live.mp4'
      this.coverUrl = 'https://source.allosoft.top/h5/main/img/Liveguide.jpg'
    }
    console.log('sourceType', this.sourceType);

    this.getLanguage(data)
    CommonModule.setLanguage(data)
  },
  methods: {
    // 切换语言
    getLanguage(language) {
      this.$i18n.locale = language
    },
    // 播放结束回调
    videoEndCallback() {
      console.log('视频播放结束啦',this.sourceType);

      if (this.sourceType == 1) {
        videoPlayEndCallback({ version: CommonModule.appVersion || '3.11.6' }).then((res) => {
          console.log('播放结束回调', res)
        })
      } else if (this.sourceType == 2) {
        liveVideoPlayEndCallback({ version: CommonModule.appVersion || '3.11.6' }).then((res) => {
          console.log('播放结束回调', res)
        })
      }
    },
    result_client() {
      if ((innerWidth - 30) * 16 / 9 > innerHeight - 80) {
        this.$refs.videoRef.style.height = innerHeight - 80 + 'px'
        this.$refs.videoRef.style.width = (innerHeight - 80) * 9 / 16 + 'px'
      } else {
        this.$refs.videoRef.style.width = innerWidth - 30 + 'px'
        this.$refs.videoRef.style.height = (innerWidth - 30) * 16 / 9 + 'px'
      }
    }
  },
  mounted() {
    // 监听视频播放结束
    this.$refs.videoRef.addEventListener('ended', this.videoEndCallback)
    setTimeout(() => {
      this.result_client()
    }, 200);
  },
  beforeDestroy() {
    // 移除视频播放结束监听
    this.$refs.videoRef.removeEventListener('ended', () => {
      console.log('播放结束回调')
    })
  }
}
</script>

<style lang="scss" scoped>
.tutorial-container {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/tutorial_bg.png') no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 15px;
}

.nav-bar {
  height: 44px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 30px;
    height: 30px;
    position: absolute;
    left: 5px;
  }

  .nav-title {
    font-size: 18px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #181818;
  }
}

.tutorial {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  .video-player {
    border-radius: 12px;
    overflow: hidden;
    background-color: #f5f5f5;
  }

  .mask {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    background: url('../../assets/Player_icon.png') no-repeat;
    background-size: cover;
    transition: all 0.5s ease-in-out;
  }
}

// 全屏按钮
video::-webkit-media-controls-fullscreen-button {
  display: none;
}

//音量按钮
video::-webkit-media-controls-mute-button {
  display: none;
}

// 画中画
video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}

//音量的控制条
video::-webkit-media-controls-volume-slider {
  display: none;
}

@keyframes player {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(4);
    opacity: 0;
  }
}

.player_animation {
  // animation: player 1s linear;;
  transition: all 0.1s ease-in-out;
}
</style>
